import { NgModule        } from '@angular/core';
import { BlockUIModule   } from 'ng-block-ui';
import { CommonModule    } from '@angular/common';
import { FormsModule     } from '@angular/forms';
import { QuillModule     } from 'ngx-quill';
import { TranslateModule } from '@ngx-translate/core';

import {
  NgbButtonsModule,
  NgbDatepickerModule,
  NgbPopoverModule,
  NgbTypeaheadModule
} from '@ng-bootstrap/ng-bootstrap';

import { CheckboxControlComponent }   from './checkbox-control/checkbox-control.component';
import { ComponentsModule }           from '../components/components.module';
import { DateControlComponent      }  from './date-control/date-control.component';
import { EmailControlComponent }      from './email-control/email-control.component';
import { FileUploadControlComponent } from './file-upload-control/file-upload-control.component';
import { FileUploadService }          from './file-upload-control/file-upload.service';
import { NumberControlComponent }     from './number-control/number-control.component';
import { PasswordControlComponent }   from './password-control/password-control.component';
import { PhoneControlComponent }      from './phone-control/phone-control.component';
import { PostcodeControlComponent }   from './postcode-control/postcode-control.component';
import { RadioGroupComponent }        from './radio-group/radio-group.component';
import { SelectControlComponent    }  from './select-control/select-control.component';
import { ShortDateControlComponent }  from './date-control/short-date-control.component';
import { SwitchControlComponent    }  from './switch-control/switch-control.component';
import { TextareaControlComponent }   from './textarea/textarea-control.component';
import { TextControlComponent      }  from './text-control/text-control.component';
import { TextEditorComponent }        from './text-editor/text-editor.component';
import { TileRadioGroupComponent }    from './tile-radio-group/tile-radio-group.component';
import { TimeControlComponent }       from './time-control/time-control.component';
import { TypeaheadControlComponent }  from './typeahead-control/typeahead-control.component';
import { UniqueTextControlComponent } from './unique-text-control/unique-text-control.component';
import { ValidatorsModule }           from '../validators/validators.module';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
  declarations: [
    CheckboxControlComponent,
    DateControlComponent,
    EmailControlComponent,
    FileUploadControlComponent,
    NumberControlComponent,
    PasswordControlComponent,
    PhoneControlComponent,
    PostcodeControlComponent,
    RadioGroupComponent,
    SelectControlComponent,
    ShortDateControlComponent,
    SwitchControlComponent,
    TextareaControlComponent,
    TextControlComponent,
    TextEditorComponent,
    TileRadioGroupComponent,
    TimeControlComponent,
    TypeaheadControlComponent,
    UniqueTextControlComponent
  ],
  entryComponents: [
    CheckboxControlComponent,
    FileUploadControlComponent,
    RadioGroupComponent,
    TextareaControlComponent,
    TextEditorComponent,
    TileRadioGroupComponent,
    TimeControlComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    NgbDatepickerModule,
    NgbTypeaheadModule,

    CheckboxControlComponent,
    DateControlComponent,
    EmailControlComponent,
    FileUploadControlComponent,
    NumberControlComponent,
    PasswordControlComponent,
    PhoneControlComponent,
    PostcodeControlComponent,
    RadioGroupComponent,
    SelectControlComponent,
    ShortDateControlComponent,
    SwitchControlComponent,
    TextareaControlComponent,
    TextControlComponent,
    TextEditorComponent,
    TileRadioGroupComponent,
    TimeControlComponent,
    TypeaheadControlComponent,
    UniqueTextControlComponent
  ],
  imports: [
    // Angular
    CommonModule,
    FormsModule,

    // Third Party
    BlockUIModule,
    NgbButtonsModule,
    NgbDatepickerModule,
    NgbPopoverModule,
    NgbTypeaheadModule,
    TranslateModule,
    QuillModule.forRoot(),

    // Custom
    ComponentsModule,
    PipesModule,
    ValidatorsModule
  ],
  providers: [
    FileUploadService
  ]
})
export class ControlsModule {}
